import { render, staticRenderFns } from "./InstructionMenu.vue?vue&type=template&id=f17ccad0&"
import script from "./InstructionMenu.vue?vue&type=script&lang=js&"
export * from "./InstructionMenu.vue?vue&type=script&lang=js&"
import style0 from "./InstructionMenu.vue?vue&type=style&index=0&id=f17ccad0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports